<template>
  <!--startprint-->
  <div class="approval">
    <div class="approval_body1">
      <div class="approval_title">干部任免审批表</div>
      <table border="1px" bordercolor="#666" width="502px" cellspacing="0" style="table-layout: fixed">
        <tr>
          <td width="54px">
            <div class="jus_title" @click="doPrint">姓名</div>
          </td>
          <td width="70px">
            <ScaleInput :type="'c_c'" :value="remRecObj.xingMing" :width="64" :height="32"></ScaleInput>
          </td>
          <td width="54px">
            <div class="jus_title">性别</div>
          </td>
          <td width="70px">
            <ScaleInput :type="'c_c'" :value="remRecObj.xingBie" :width="64" :height="32"></ScaleInput>
          </td>
          <td width="74px">出生年月（岁）</td>
          <td width="70px">
            <div>{{ formatDate(remRecObj.chuShengNianYue) }}</div>
            <div v-show="remRecObj.chuShengNianYue">（{{ transAge(remRecObj.chuShengNianYue) }}岁）</div>
          </td>
          <td width="110px" rowspan="4" :style="backgroundStyle">
<!--            <img v-if="remRecObj.zhaoPian" :src="'data:image/png;base64,' + remRecObj.zhaoPian" alt="照片" style="width:100px">-->
            <span v-if="!remRecObj.zhaoPian">照&nbsp片</span>
          </td>
        </tr>
        <tr>
          <td>
            <div class="jus_title">民族</div>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="remRecObj.minZu" :width="64" :height="32"></ScaleInput>
          </td>
          <td>
            <div class="jus_title">籍贯</div>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="remRecObj.jiGuan" :width="64" :height="32"></ScaleInput>
          </td>
          <td>
            <div class="jus_title" style="padding: 0 7px">出生地</div>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="remRecObj.chuShengDi" :width="64" :height="32"></ScaleInput>
          </td>
        </tr>
        <tr>
          <td>
            <div class="jus_title">入党</div>
            <div class="jus_title">时间</div>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="formatDate(remRecObj.ruDangShiJian)" :width="64" :height="32"></ScaleInput>
          </td>
          <td>
            <div class="jus_title">参加工</div>
            <div class="jus_title">作时间</div>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="formatDate(remRecObj.canJiaGongZuoShiJian)" :width="64" :height="32"></ScaleInput>
          </td>
          <td>健康状况</td>
          <td>
            <ScaleInput :type="'c_c'" :value="remRecObj.jianKangZhuangKuang" :width="64" :height="32"></ScaleInput>
          </td>
        </tr>
        <tr>
          <td>
            <div class="jus_title">专业技</div>
            <div class="jus_title">术职务</div>
          </td>
          <td colspan="2">
            <ScaleInput :type="'c_c'" :value="remRecObj.zhuanYeJiShuZhiWu" :width="118" :height="32"></ScaleInput>
          </td>
          <td>熟悉专业<br>有何特长</td>
          <td colspan="2">
            <ScaleInput :type="'c_c'" :value="remRecObj.shuXiZhuanYeYouHeZhuanChang" :width="138"
                        :height="32"></ScaleInput>
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            <div class="jus_title">学历</div>
            <div class="jus_title">学位</div>
          </td>
          <td style="padding: 0 7px">
            <div class="jus_title">全日制</div>
            <div class="jus_title">教育</div>
          </td>
          <td colspan="2">
            <ScaleInput :type="'c_c'" :value="remRecObj.quanRiZhiJiaoYu_XueLi" :width="118" :height="18"></ScaleInput>
            <ScaleInput :type="'c_c'" :value="remRecObj.quanRiZhiJiaoYu_XueWei" :width="118" :height="18"></ScaleInput>
          </td>
          <td>毕业院校<br>系及专业</td>
          <td colspan="2">
            <ScaleInput :type="'l_c'" :value="remRecObj.quanRiZhiJiaoYu_XueLi_BiYeYuanXiaoXi" :width="173"
                        :height="18"></ScaleInput>
            <ScaleInput :type="'l_c'" :value="remRecObj.quanRiZhiJiaoYu_XueWei_BiYeYuanXiaoXi" :width="173"
                        :height="18"></ScaleInput>
          </td>
        </tr>
        <tr>
          <td style="padding: 0 7px">
            <div class="jus_title">在职</div>
            <div class="jus_title">教育</div>
          </td>
          <td colspan="2">
            <ScaleInput :type="'c_c'" :value="remRecObj.zaiZhiJiaoYu_XueLi" :width="118" :height="18"></ScaleInput>
            <ScaleInput :type="'c_c'" :value="remRecObj.zaiZhiJiaoYu_XueWei" :width="118" :height="18"></ScaleInput>
          </td>
          <td>毕业院校<br>系及专业</td>
          <td colspan="2">
            <ScaleInput :type="'l_c'" :value="remRecObj.zaiZhiJiaoYu_XueLi_BiYeYuanXiaoXi" :width="173"
                        :height="18"></ScaleInput>
            <ScaleInput :type="'l_c'" :value="remRecObj.zaiZhiJiaoYu_XueWei_BiYeYuanXiaoXi" :width="173"
                        :height="18"></ScaleInput>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="jus_title">现任职务</div>
          </td>
          <td colspan="5">
            <ScaleInput :type="'l_c'" :value="remRecObj.xianRenZhiWu" :width="371" :height="32"></ScaleInput>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="jus_title">拟任职务</div>
          </td>
          <td colspan="5">
            <ScaleInput :type="'l_c'" :value="remRecObj.niRenZhiWu" :width="371" :height="32"></ScaleInput>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="jus_title">拟免职务</div>
          </td>
          <td colspan="5">
            <ScaleInput :type="'l_c'" :value="remRecObj.niMianZhiWu" :width="371" :height="32"></ScaleInput>
          </td>
        </tr>
        <tr style="height:381px">
          <td colspan="7">
            <div class="jianli_title">
              <div>简</div>
              <div>历</div>
            </div>
            <div style="width: 450px;height:381px;float: right;padding-top: 4px;">
              <ScaleInputJl v-show="jlFom != null && jlFom.length > 0" :jlArr="jlFom" :width="449"
                            :height="371"></ScaleInputJl>
              <ScaleInput v-show="jlFom == null || jlFom.length == 0" :type="'l_t'" :value="remRecObj.jianLi"
                          :width="449" :height="371"></ScaleInput>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="approval_body2">
      <table border="1px" bordercolor="#666" width="502px" cellspacing="0" style="table-layout: fixed">
        <tr class="table2_first_row">
          <td width="40px"></td>
          <td width="58px"></td>
          <td width="66px"></td>
          <td width="30px"></td>
          <td width="54px"></td>
          <td width="40px"></td>
          <td width="211px"></td>
        </tr>
        <tr style="height: 74px">
          <td>
            <div style="height: 70px;width: 14px;writing-mode: vertical-lr;margin: auto;letter-spacing: 2px;">奖惩情况</div>
          </td>
          <td colspan="6">
            <ScaleInput :type="'l_c'" :value="remRecObj.jiangChengQingKuang" :width="453" :height="66"></ScaleInput>
          </td>
        </tr>
        <tr style="height: 56px">
          <td>
            <div style="height: 50px;width: 30px;margin: auto;writing-mode: vertical-lr;letter-spacing: 2px;">年度考核结果
            </div>
          </td>
          <td colspan="6">
            <ScaleInput :type="'l_c'" :value="remRecObj.nianDuKaoHeJieGuo" :width="453" :height="49"></ScaleInput>
          </td>
        </tr>
        <tr style="height: 74px">
          <td>
            <div style="height: 70px;width: 14px;writing-mode: vertical-lr;margin: auto;letter-spacing: 2px;">任免理由</div>
          </td>
          <td colspan="6">
            <ScaleInput :type="'l_c'" :value="remRecObj.renMianLiYou" :width="453" :height="66"></ScaleInput>
          </td>
        </tr>
        <tr style="height: 36px">
          <td :rowspan="familyShowLinesNum+1">
            <div style="height: 230px;width: 14px;writing-mode: vertical-lr;margin: auto;letter-spacing: 3px;">
              家庭主要成员及重要社会关系
            </div>
          </td>
          <td>
            <div class="jus_title" style="padding: 0 8px">称谓</div>
          </td>
          <td>
            <div class="jus_title" style="padding: 0 8px">姓名</div>
          </td>
          <td>
            <div style="writing-mode: vertical-lr;margin: auto">年龄</div>
          </td>
          <td>
            <div class="jus_title" style="padding: 0 8px">政治</div>
            <div class="jus_title" style="padding: 0 8px">面貌</div>
          </td>
          <td colspan="2">
            <div style="letter-spacing: 8px">工作单位及职务</div>
          </td>
        </tr>
        <tr v-for="(item,index) in familyShowLinesNum" :style="{'height':familyEntryAllH/familyShowLinesNum+'px'}">
          <td>
            <ScaleInput :type="'c_c'" :value="familyMembers[index].chengWei" :width="52"
                        :height="familyEntryAllH/familyShowLinesNum - 6"></ScaleInput>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="familyMembers[index].xingMing" :width="60"
                        :height="familyEntryAllH/familyShowLinesNum - 6"></ScaleInput>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="transAge(familyMembers[index].chuShengRiQi)" :width="24"
                        :height="familyEntryAllH/familyShowLinesNum - 6"></ScaleInput>
          </td>
          <td>
            <ScaleInput :type="'c_c'" :value="familyMembers[index].zhengZhiMianMao" :width="48"
                        :height="familyEntryAllH/familyShowLinesNum - 6"></ScaleInput>
          </td>
          <td colspan="2">
            <ScaleInput :type="'l_c'" :value="familyMembers[index].gongZuoDanWeiJiZhiWu" :width="245"
                        :height="familyEntryAllH/familyShowLinesNum - 6"></ScaleInput>
          </td>
        </tr>
        <tr style="height: 78px">
          <td>
            <div style="height: 70px;width: 14px;writing-mode: vertical-lr;margin: auto;letter-spacing: 2px;">呈报单位</div>
          </td>
          <td colspan="6">
            <ScaleInput :type="'l_c'" :value="remRecObj.chengBaoDanWei" :width="453" :height="40"></ScaleInput>
            <div class="date_view">
              {{ fillFormTime[0] }}
              <span>年</span>
              {{ fillFormTime[1] }}
              <span v-if="!fillFormTime[0] || fillFormTime[1]">月</span>
              {{ fillFormTime[2] }}
              <span v-if="!fillFormTime[0] || fillFormTime[2]">日</span>
            </div>
          </td>
        </tr>
        <tr style="height: 78px">
          <td>
            <div
                style="height: 70px;width: 30px;writing-mode: vertical-lr;margin: auto;letter-spacing: 3px;text-align-last: justify">
              审批机关<br>意见
            </div>
          </td>
          <td colspan="4">
            <div style="height:20px"></div>
            <div style="text-align: right;letter-spacing: 3px;padding-right: 21px;margin-bottom: 5px">（盖章）</div>
            <div class="date_view">
              <span>年</span>
              <span>月</span>
              <span>日</span>
            </div>
          </td>
          <td>
            <div
                style="height: 70px;width: 30px;writing-mode: vertical-lr;margin: auto;letter-spacing: 3px;text-align-last: justify">
              行政机关<br>任免意见
            </div>

          </td>
          <td>
            <div style="height:20px"></div>
            <div style="text-align: right;letter-spacing: 3px;padding-right: 21px;margin-bottom: 5px">（盖章）</div>
            <div class="date_view">
              <span>年</span>
              <span>月</span>
              <span>日</span>
            </div>
          </td>
        </tr>
      </table>
      <div class="fillform_p">填表人：{{ remRecObj.tianBiaoRen }}</div>
    </div>


  </div>
  <!--endprint-->
</template>
<script>
import ScaleInput from "./ScaleInput.vue";
import ScaleInputJl from "./ScaleInputJl.vue";

export default {
  components: {
    ScaleInput,
    ScaleInputJl
  },
  props: {
    remRecData: Array,
    cusParam_op: String
  },
  computed: {
    fillFormTime() {
      let timeStr = this.remRecObj.tianBiaoShiJian;
      if (timeStr == null || timeStr === '') {
        return ['', '', '']
      } else {
        return [timeStr.slice(0, 4), timeStr.slice(4, 6), timeStr.slice(6, 8)]
      }
    },
    jlFom() {
      if (this.remRecObj.jianLi != null && this.isJSON(this.remRecObj.jianLi)) {
        console.log(JSON.parse(this.remRecObj.jianLi));
        return JSON.parse(this.remRecObj.jianLi);
      }else {
        return null;
      }
    },
    backgroundStyle() {
      if (this.remRecObj.zhaoPian) {
        return {
          'background-image': `url(data:image/png;base64,${this.remRecObj.zhaoPian})`,
          'background-size': 'cover',
          'background-position-x': '-1px',
          'background-repeat': 'no-repeat',
        };
      } else {
        return {}; // 如果没有图片，返回一个空对象
      }
    },
  },
  watch: {
    remRecData: function (val) {
      if (val != null && val.length > 0) {
        this.remRecObj = val[0];
        if (this.remRecObj.jiaTingChengYuan != null && this.remRecObj.jiaTingChengYuan.length > 0) {
          let familyMems = this.remRecObj.jiaTingChengYuan.length;
          this.familyShowLinesNum = familyMems > 7 ? (familyMems > 10 ? 10 : familyMems) : 7;
          this.familyMembers = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
          for (let index = 0; index < familyMems; index++) {
            this.familyMembers[index] = this.remRecObj.jiaTingChengYuan[index];
          }
        } else {
          this.familyShowLinesNum = 7;
        }
      }
    },
    cusParam_op: function (val) {
      console.log($(".approval")[0].innerHTML);
      this.invoke("form_html", $(".approval")[0].innerHTML)
    }
  },
  data() {
    return {
      memberNum: 10,
      remRecObj: {},
      familyMembers: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      familyShowLinesNum: 10,
      familyEntryAllH: 320,
    }
  },
  mounted() {

  },
  methods: {
    transAge(birthStr) {
      if (birthStr != null && birthStr !== '') {
        let year = birthStr.slice(0, 4);
        let month = birthStr.slice(4, 6);
        let birthDateTime = new Date(year + '-' + month).getTime();
        let nowDateTime = new Date().getTime();
        return Math.floor((nowDateTime - birthDateTime) / 31536000000) + '';
      } else {
        return null;
      }
    },
    formatDate(str){
      if(str != null && str.length === 6){
        return str.slice(0,4) + "." + str.slice(4,6);
      }else {
        return str
      }
    },
    doPrint() {
      let bdhtml = window.document.body.innerHTML;
      let sprnstr = '<!--startprint-->';
      let eprnstr = '<!--endprint-->';
      let prnhtml = bdhtml.substr(bdhtml.indexOf(sprnstr) + 17);
      prnhtml = prnhtml.substring(0, prnhtml.indexOf(eprnstr));
      window.document.body.innerHTML = prnhtml;
      window.print();
    },
    isJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (error) {
        return false;
      }
    }
  }
}
</script>
<style lang="less">
.approval {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #000;
  font-family: monospace;

  .jus_title {
    text-align-last: justify;
    padding: 0 2px;
  }

  .date_view {
    text-align: right;

    span {
      margin: 0 10px;
    }
  }

  .approval_body1 {
    width: 630px;
    height: 891px;
    padding-top: 42px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
    flex-shrink: 0;
    background: #fff;

    .approval_title {
      font-size: 24px;
      font-family: monospace;
      color: #212121;
      letter-spacing: 13.4px;
      text-align: center;
      margin-bottom: 8px;
    }

    .jianli_title {
      width: 42px;
      height: 381px;
      border-right: 2px solid rgb(102, 102, 102);
      float: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 130px 0;
    }

    td {
      height: 37px;
      text-align: center;
      padding: 0 2px;
    }
  }

  .approval_body2 {
    width: 630px;
    height: 891px;
    margin-top: 20px;
    padding-top: 83px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 4px 4px 16px 0px rgba(0, 0, 0, 0.08);
    flex-shrink: 0;
    background: #fff;

    .fillform_p {
      align-self: start;
      padding-left: 88px;
      padding-top: 5px;
    }

    .table2_first_row {
      td {
        height: 0;
        border: 0;
      }
    }

    td {
      height: 32px;
      text-align: center;
      padding: 0 2px;
    }
  }

  table {

  }

  tr {

  }


}
</style>